/* globals jQuery */
jQuery( $ => {
	const $window = $( window );
	const $document = $( document );
	const $body = $( 'body' );

	// =========================
	// ! Supports Flagging
	// =========================

	$body.removeClass( 'no-js' ).addClass( 'js' );

	$document
		.on( 'touchstart', function() {
			$body.removeClass( 'notouch' ).addClass( 'touch' );
		} )
		.on( 'mousedown', function() {
			$body.addClass( 'using-mouse' );
		} )
		.on( 'keydown', function() {
			$body.removeClass( 'using-mouse' );
		} );

	// =========================
	// ! Effects and Helpers
	// =========================

	$( '.wp-block-image > a[data-display]' ).each( function() {
		$( this ).append( $( '<span class="wp-block-image__tooltip"></span>' ).text( $( this ).data( 'display' ) ) );
	} );

	// =========================
	// ! Accordion
	// =========================

	$( '.premise-accordion' ).each( function() {
		const $self = $( this );
		const $header = $self.find( '.premise-accordion__header' );
		const $content = $self.find( '.premise-accordion__content' );

		$header.click( function() {
			$self.toggleClass( 'is-open' );
			if ( $self.hasClass( 'is-open' ) ) {
				$content.addClass( 'open' ).stop().hide().animate( { height: 'toggle' }, () => $content.attr( 'style', '' ) );
				$self.siblings().each( function() {
					if ( $( this ).hasClass( 'is-open' ) ) {
						$( this ).removeClass( 'is-open' );
						$( this ).find( '.premise-accordion__content' ).stop().show().animate( { height: 'toggle' }, function() {
							$( this ).attr( 'style', '' ).removeClass( 'open' );
						} );
					}
				} );
			} else {
				$content.stop().show().animate( { height: 'toggle' }, function() {
					$( this ).attr( 'style', '' ).removeClass( 'open' );
				} );
			}
		} );
	} );
} );
